import React, { useEffect } from "react";
import AdminsTemplate from "../components/templates/AdminsTemplate";
import { useSession } from "../context/SessionContext";
import { useNavigate } from "react-router-dom";

const Admins = () => {
    const { user } = useSession();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.role !== "Admin") {
            navigate("/dashboard");
        }
    }, [user, navigate]);

    if (!user || user.role !== "Admin") {
        return null;
    }

    return <AdminsTemplate />;
};

export default Admins;